export default __webpack_public_path__ + "4143c2d99bb11fbdb3de348cf76a3b0a.jpg";